import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Button,
  Paper,
  Box,
  InputAdornment,

  Checkbox,
  OutlinedInput,
  ListItemText,
      Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const SwitchOn = ({ demographicData, onSubmit = () => { } }) => {
  const [formData, setFormData] = useState({
    switchOnCenter: '',
    dateOfSwitchOn: '',
    surgeonName: '',
    surgeryCenter: '',
    audiologistName: '',
    referralLetter: '',
    earData: {
      right: {
        modelOfImplant: '',
        modelOfSpeechProcessor: '',
        subjective: '', // '' | 'Yes' | 'No'
        objective: {
          nrt: false,
          esrt: false,
          ecap: false,
        },
      },
      left: {
        modelOfImplant: '',
        modelOfSpeechProcessor: '',
        subjective: '',
        objective: {
          nrt: false,
          esrt: false,
          ecap: false,
        },
      },
    },
    documents: {
      kitCounselling: null,
      dischargeSummary: null,
      postOpXray: null,
      mapReport: null,
    },
    remarks: '',
    mappingAppointments: [],
    selectedAppointment: '',
  });

  const [searchOpNumber, setSearchOpNumber] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [downloadFormat, setDownloadFormat] = useState('excel');

  const handleSwitchOnChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Generic handler for ear simple fields (modelOfImplant, modelOfSpeechProcessor, subjective)
  const handleEarDataChange = (ear, field, value) => {
    setFormData((prev) => ({
      ...prev,
      earData: {
        ...prev.earData,
        [ear]: {
          ...prev.earData[ear],
          [field]: value,
        },
      },
    }));
  };


  // Convert objective object -> array of labels for Select value
  const objectiveObjToArray = (obj) => {
    if (!obj || typeof obj !== 'object') return [];
    const arr = [];
    if (obj.nrt) arr.push('NRT');
    if (obj.esrt) arr.push('ESRT');
    if (obj.ecap) arr.push('ECAP');
    return arr;
  };

  // Convert selected array back to objective object shape
  const objectiveArrayToObj = (arr) => {
    const newObj = { nrt: false, esrt: false, ecap: false };
    (arr || []).forEach((item) => {
      if (item === 'NRT') newObj.nrt = true;
      if (item === 'ESRT') newObj.esrt = true;
      if (item === 'ECAP') newObj.ecap = true;
    });
    return newObj;
  };

  // Handler used by the multi-select onChange — converts array -> object and stores it
  const handleObjectiveSelectChange = (ear, event) => {
    const raw = typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value;
    const newObj = objectiveArrayToObj(raw);
    handleEarDataChange(ear, 'objective', newObj);
  };

  const handleFileChange = (fileType, file) => {
    setFormData((prev) => ({
      ...prev,
      documents: {
        ...prev.documents,
        [fileType]: file,
      },
    }));
  };
  const handleSearch = async () => {
    if (!searchOpNumber.trim()) {
      alert('Please enter an OP number');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/switchon/search/${searchOpNumber}`);

      if (response.ok) {
        const patientData = await response.json();
        setSearchResult(patientData);
        setIsFormVisible(true);

        // Pre-fill the form with existing data if available
        try {
          const existingDataResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/switchon/${searchOpNumber}`);
          if (existingDataResponse.ok) {
            const existingData = await existingDataResponse.json();
            setFormData(prev => ({
              ...prev,
              switchOnCenter: existingData.switch_on_center || '',
              dateOfSwitchOn: existingData.date_of_switch_on || '',
              surgeonName: existingData.surgeon_name || '',
              surgeryCenter: existingData.surgery_center || '',
              audiologistName: existingData.audiologist_name || '',
              referralLetter: existingData.referral_letter || '',
              remarks: existingData.remarks || '',
              earData: {
                right: {
                  modelOfImplant: existingData.right_model_of_implant || '',
                  modelOfSpeechProcessor: existingData.right_model_of_speech_processor || '',
                  subjective: existingData.right_subjective || '',
                  objective: {
                    nrt: existingData.right_objective_nrt || false,
                    esrt: existingData.right_objective_esrt || false,
                    ecap: existingData.right_objective_ecap || false,
                  }
                },
                left: {
                  modelOfImplant: existingData.left_model_of_implant || '',
                  modelOfSpeechProcessor: existingData.left_model_of_speech_processor || '',
                  subjective: existingData.left_subjective || '',
                  objective: {
                    nrt: existingData.left_objective_nrt || false,
                    esrt: existingData.left_objective_esrt || false,
                    ecap: existingData.left_objective_ecap || false,
                  }
                }
              }
            }));
            setDate(existingData.date_of_switch_on || '');
          }
        } catch (error) {
          console.log('No existing data found, starting with fresh form');
        }
      } else {
        alert('Patient not found. Please check the OP number.');
        setSearchResult(null);
        setIsFormVisible(false);
      }
    } catch (error) {
      console.error('Error searching for patient:', error);
      alert('Error searching for patient');
      setSearchResult(null);
      setIsFormVisible(false);
    }
  };
  const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Switch On CI ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "switch_on_ci",
          formName: "Switch_On_CI",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Switch_On_CI_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };
  const handleSubmit = async () => {
    if (!searchOpNumber.trim()) {
      alert('Please search for a patient first');
      return;
    }

    try {
      const formDataToSend = new FormData();

      // Add all form data
      formDataToSend.append('opNumber', searchOpNumber);
      formDataToSend.append('dateOfSwitchOn', formData.dateOfSwitchOn);
      formDataToSend.append('switchOnCenter', formData.switchOnCenter);
      formDataToSend.append('surgeonName', formData.surgeonName);
      formDataToSend.append('surgeryCenter', formData.surgeryCenter);
      formDataToSend.append('audiologistName', formData.audiologistName);
      formDataToSend.append('referralLetter', formData.referralLetter);
      formDataToSend.append('earData', JSON.stringify(formData.earData));
      formDataToSend.append('remarks', formData.remarks);

      // Add files if they exist
      if (formData.documents.kitCounselling) {
        formDataToSend.append('kitCounselling', formData.documents.kitCounselling);
      }
      if (formData.documents.dischargeSummary) {
        formDataToSend.append('dischargeSummary', formData.documents.dischargeSummary);
      }
      if (formData.documents.postOpXray) {
        formDataToSend.append('postOpXray', formData.documents.postOpXray);
      }
      if (formData.documents.mapReport) {
        formDataToSend.append('mapReport', formData.documents.mapReport);
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/switchon`, {
        method: 'POST',
        body: formDataToSend,
      });

      if (response.ok) {
        const result = await response.json();
        alert('Switch-on data saved successfully!');
        console.log('Saved data:', result.data);
      } else {
        const error = await response.json();
        alert(`Error saving data: ${error.error}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error submitting form');
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 1200, margin: 'auto', mt: 4, mb: 6, borderRadius: 2 }}>
  
      <Card elevation={2} sx={{ borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2', mb: 2 }}>
            Switch-On Details
          </Typography>
          <Divider sx={{ mb: 3 }} />

          {/* Search Section */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Search OP Number"
                value={searchOpNumber}
                onChange={(e) => setSearchOpNumber(e.target.value)}
                variant="outlined"
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleSearch}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Button fullWidth variant="contained" color="primary" onClick={handleSearch} sx={{ py: 1.5, borderRadius: 1 }}>
                Search Patient
              </Button>
            </Grid>
          </Grid>

          {/* Demographic Info */}
          {searchResult && (
            <Paper elevation={1} sx={{ p: 3, mb: 4, bgcolor: '#e3f2fd', borderRadius: 1 }}>
                    <Box sx={{ position: 'absolute', top: 350, right: 160 }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}
              >
                Download 
              </Button>
            </Box>
              <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 2 }}>
                Patient Demographic Information
              </Typography>
               <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography><strong>Name:</strong> {searchResult.name || 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography><strong>Age:</strong> {searchResult.age || 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography><strong>IP Number:</strong> {searchResult.ip_number || 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography><strong>OP Number:</strong> {searchResult.op_number || 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography><strong>Phone:</strong> {searchResult.phone || 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography><strong>Address:</strong> {searchResult.address || 'N/A'}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography><strong>Medical History:</strong> {searchResult.history || 'N/A'}</Typography>
                  </Grid>
                </Grid>

            </Paper>
          )}

          {isFormVisible && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={3}>
                {/* Section 1: Switch-On Information */}
                <Grid container item xs={12} spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Date of Switch-On"
                      type="date"
                      name="dateOfSwitchOn"
                      value={formData.dateOfSwitchOn}
                      onChange={handleSwitchOnChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Switch-On Center"
                      name="switchOnCenter"
                      value={formData.switchOnCenter}
                      onChange={handleSwitchOnChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Name of Surgeon"
                      name="surgeonName"
                      value={formData.surgeonName}
                      onChange={handleSwitchOnChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Surgery Center"
                      name="surgeryCenter"
                      value={formData.surgeryCenter}
                      onChange={handleSwitchOnChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </Grid>

                {/* Section 2: Audiologist Information */}
                <Grid container item xs={12} spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Name of Audiologist"
                      name="audiologistName"
                      value={formData.audiologistName}
                      onChange={handleSwitchOnChange}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel shrink={true}>Referral Letter Received</InputLabel>
                      <Select
                        name="referralLetter"
                        value={formData.referralLetter}
                        onChange={handleSwitchOnChange}
                        label="Referral Letter Received"
                        displayEmpty
                        renderValue={(value) => value || 'Select Referral Letter'}
                      >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                        <MenuItem value="NA">NA</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Section 3: Ear-Specific Device Information */}
                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium', mb: 2 }}>
                    Device Information by Ear
                  </Typography>
                  <Divider sx={{ mb: 2 }} />

                  {/* Header Row */}
                  <Grid container spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        Ear
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Right
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={5} sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Left
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Model of Implant Row */}
                  <Grid container spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
                    <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography>Model of Implant</Typography>
                    </Grid>

                    <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={formData.earData.right.modelOfImplant}
                        onChange={(e) => handleEarDataChange('right', 'modelOfImplant', e.target.value)}
                        placeholder="Enter model for right ear"
                      />
                    </Grid>

                    <Grid item xs={12} sm={5} sx={{ display: 'flex', alignItems: 'center' }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={formData.earData.left.modelOfImplant}
                        onChange={(e) => handleEarDataChange('left', 'modelOfImplant', e.target.value)}
                        placeholder="Enter model for left ear"
                      />
                    </Grid>
                  </Grid>

                  {/* Model of Speech Processor Row */}
                  <Grid container spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
                    <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography>Model of Speech Processor</Typography>
                    </Grid>

                    <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={formData.earData.right.modelOfSpeechProcessor}
                        onChange={(e) => handleEarDataChange('right', 'modelOfSpeechProcessor', e.target.value)}
                        placeholder="Enter processor for right ear"
                      />
                    </Grid>

                    <Grid item xs={12} sm={5} sx={{ display: 'flex', alignItems: 'center' }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={formData.earData.left.modelOfSpeechProcessor}
                        onChange={(e) => handleEarDataChange('left', 'modelOfSpeechProcessor', e.target.value)}
                        placeholder="Enter processor for left ear"
                      />
                    </Grid>
                  </Grid>

                  {/* Subjective Row (dropdown Yes/No) */}
                  <Grid container spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
                    <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography>Subjective</Typography>
                    </Grid>

                    <Grid item xs={12} sm={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="right-subjective-label" shrink={true}>Right</InputLabel>
                        <Select
                          labelId="right-subjective-label"
                          value={formData.earData.right.subjective ?? ''}
                          label="Right"
                          onChange={(e) => handleEarDataChange('right', 'subjective', e.target.value)}
                          displayEmpty
                          renderValue={(val) => (val ? val : 'Select')}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={5} sx={{ display: 'flex', justifyContent: 'center' }}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="left-subjective-label" shrink={true}>Left</InputLabel>
                        <Select
                          labelId="left-subjective-label"
                          value={formData.earData.left.subjective ?? ''}
                          label="Left"
                          onChange={(e) => handleEarDataChange('left', 'subjective', e.target.value)}
                          displayEmpty
                          renderValue={(val) => (val ? val : 'Select')}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* Objective Row (multi-select for each ear) */}
                  <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                    <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography>Objective</Typography>
                    </Grid>

                    {/* Right Ear Objective Multi-select */}
                    <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="right-objective-label" shrink={true}>Right</InputLabel>
                        <Select
                          labelId="right-objective-label"
                          multiple
                          value={objectiveObjToArray(formData.earData.right.objective)}
                          onChange={(e) => handleObjectiveSelectChange('right', e)}
                          input={<OutlinedInput label="Right" />}
                          displayEmpty
                          renderValue={(selected) => (selected && selected.length ? selected.join(', ') : 'Select')}
                        >


                          <MenuItem value="NRT">
                            <Checkbox checked={formData.earData.right.objective.nrt} />
                            <ListItemText primary="NRT" />
                          </MenuItem>
                          <MenuItem value="ESRT">
                            <Checkbox checked={formData.earData.right.objective.esrt} />
                            <ListItemText primary="ESRT" />
                          </MenuItem>
                          <MenuItem value="ECAP">
                            <Checkbox checked={formData.earData.right.objective.ecap} />
                            <ListItemText primary="ECAP" />
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Left Ear Objective Multi-select */}
                    <Grid item xs={12} sm={5} sx={{ display: 'flex', alignItems: 'center' }}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="left-objective-label" shrink={true}>Left</InputLabel>
                        <Select
                          labelId="left-objective-label"
                          multiple
                          value={objectiveObjToArray(formData.earData.left.objective)}
                          onChange={(e) => handleObjectiveSelectChange('left', e)}
                          input={<OutlinedInput label="Left" />}
                          displayEmpty
                          renderValue={(selected) => (selected && selected.length ? selected.join(', ') : 'Select')}
                        >
                          <MenuItem value="NRT">
                            <Checkbox checked={formData.earData.left.objective.nrt} />
                            <ListItemText primary="NRT" />
                          </MenuItem>
                          <MenuItem value="ESRT">
                            <Checkbox checked={formData.earData.left.objective.esrt} />
                            <ListItemText primary="ESRT" />
                          </MenuItem>
                          <MenuItem value="ECAP">
                            <Checkbox checked={formData.earData.left.objective.ecap} />
                            <ListItemText primary="ECAP" />
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Section 4: Documents */}
                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'medium', mb: 1 }}>
                    Documents to be Uploaded
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Kit List"
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handleFileChange('kitCounselling', e.target.files[0])}
                        variant="outlined"
                        size="small"
                        helperText={formData.documents.kitCounselling ? formData.documents.kitCounselling.name : 'No file selected'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Discharge Summary"
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handleFileChange('dischargeSummary', e.target.files[0])}
                        variant="outlined"
                        size="small"
                        helperText={formData.documents.dischargeSummary ? formData.documents.dischargeSummary.name : 'No file selected'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Post-Op X-Ray Report"
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handleFileChange('postOpXray', e.target.files[0])}
                        variant="outlined"
                        size="small"
                        helperText={formData.documents.postOpXray ? formData.documents.postOpXray.name : 'No file selected'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Map Report"
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handleFileChange('mapReport', e.target.files[0])}
                        variant="outlined"
                        size="small"
                        helperText={formData.documents.mapReport ? formData.documents.mapReport.name : 'No file selected'}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Section 5: Remarks */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Switch-On Remarks"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleSwitchOnChange}
                    multiline
                    rows={2}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </CardContent>
      </Card>
    {/* Password Modal */}
      <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
      {/* Save Button */}
      {isFormVisible && (
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{
              px: 6,
              py: 1.5,
              borderRadius: 2,
              fontSize: '1rem',
              minWidth: '250px',
            }}
          >
            Submit
          </Button>
        </Grid>
      )}
    </Paper>
  );
};

export default SwitchOn;
